import { useState, useRef } from "react";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";

const libraries: "places"[] = ["places"];

const AddressAutocomplete = ({ form }: { form: any }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState(form.values.homeAddress || "");

  const handlePlaceSelect = () => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current.getPlace();

    if (!place || !place.address_components) return;

    const address = place.formatted_address || "";
    const city =
      place.address_components.find((component) =>
        component.types.includes("locality"),
      )?.long_name || "";
    const state =
      place.address_components.find((component) =>
        component.types.includes("administrative_area_level_1"),
      )?.long_name || "";
    const zipCode =
      place.address_components.find((component) =>
        component.types.includes("postal_code"),
      )?.long_name || "";
    setInputValue(address);
    form.setFieldValue("homeAddress", address);
    form.setFieldValue("city", city);
    form.setFieldValue("state", state);
    form.setFieldValue("zipCode", zipCode.replace(" ", ""));
  };

  if (!isLoaded) return <p>Loading...</p>;

  return (
    <Autocomplete
      onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
      onPlaceChanged={handlePlaceSelect}
      options={{
        types: ["address"],
        componentRestrictions: { country: "ca" },
      }}
    >
      <input
        type="text"
        placeholder="Enter your Home address"
        className={`mt-3 p-2 border rounded w-full ${form.touched.homeAddress && form.errors.homeAddress ? "border-red-600" : "border-[#D0D5DD]"}`}
        value={inputValue}
        onChange={(e) => {
          form.setFieldValue("homeAddress", e.target.value);
          setInputValue(e.target.value);
        }}
      />
    </Autocomplete>
  );
};

export default AddressAutocomplete;
